import { Badge, Dropdown } from '@iveco-ti/iveco-ds'
import { LayoutGrid } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { useAppConfig } from '../hooks/useAppConfig'

export function QuickAccessTools() {
  const { APPS } = useAppConfig()
  const { t } = useTranslation('common')

  if (APPS.length === 0) return null

  return (
    <Dropdown.Root className="[--strategy:absolute] max-w-24" openMode="hover">
      <Dropdown.Trigger asChild>
        <button
          type="button"
          className="space-y-1 hover:bg-base-100 p-2 rounded truncate"
        >
          <LayoutGrid className="text-brand-800 mx-auto size-7" />
          <span className="text-sm font-semibold text-gray-700">
            {t('sidebar.app_selection.quick_access')}
          </span>
        </button>
      </Dropdown.Trigger>

      <Dropdown.Body>
        <Dropdown.List>
          {APPS.map((app) => (
            <Dropdown.Item
              key={app.name}
              className="flex items-center justify-between"
              onClick={app.onItemClick}
            >
              <span>{app.name}</span>

              {app.badge && (
                <Badge.Root size="sm" colors={app.badgeColor}>
                  {app.badge}
                </Badge.Root>
              )}
            </Dropdown.Item>
          ))}
        </Dropdown.List>
      </Dropdown.Body>
    </Dropdown.Root>
  )
}
